import { z } from 'zod';
import type { IConfigParamsFormValues } from '@/modules/gpt-chats/types/tools.service.type';

export const configParamsSchema = z.object({
  transportMethod: z.enum(['sse', 'streamable_http']),
  serverUrl: z
    .string()
    .trim()
    .min(1, 'URL is required')
    .url('URL must start with http:// or https://')
    .refine(
      (url) => url.startsWith('http://') || url.startsWith('https://'),
      'URL must start with http:// or https://'
    ),
  authType: z.enum([
    'none',
    'bearer',
    'basic',
    'api_token',
    'oauth2',
    'oauth2_client_credentials',
    'oauth2_authorization_code',
  ]),
  trustMcpServer: z.boolean(),
  authLocation: z.enum(['header', 'query']).optional(),
  authKeyName: z.string().trim().optional(),
  authKeyPrefix: z.string().optional(),
  apiToken: z.string().optional(),
  username: z.string().trim().optional(),
  password: z.string().optional(),
  clientId: z.string().optional(),
  clientSecret: z.string().optional(),
  tokenUrl: z.string().trim().optional(),
  scopes: z.string().trim().optional(),
  clientIdAuthCode: z.string().trim().optional(),
  clientSecretAuthCode: z.string().trim().optional(),
  tokenUrlAuthCode: z.string().optional(),
  authorizationUrl: z.string().trim().optional(),
  redirectUri: z.string().trim().optional(),
  scopesAuthCode: z.string().trim().optional(),
  isAuthenticated: z.boolean().optional(),
  grantType: z.enum(['authorization_code', 'client_credentials', 'refresh_token']).optional(),
  headers: z.array(z.object({ key: z.string().trim(), value: z.string().trim() })),
  queryParams: z.array(z.object({ key: z.string().trim(), value: z.string().trim() })),
});

export const configParamsDefaultValues: IConfigParamsFormValues = {
  transportMethod: 'streamable_http',
  serverUrl: '',
  authType: 'none',
  trustMcpServer: false,
  authLocation: 'header',
  authKeyName: '',
  authKeyPrefix: '',
  apiToken: '',
  username: '',
  password: '',
  clientId: '',
  clientSecret: '',
  tokenUrl: '',
  scopes: '',
  clientIdAuthCode: '',
  clientSecretAuthCode: '',
  tokenUrlAuthCode: '',
  authorizationUrl: '',
  redirectUri: '',
  scopesAuthCode: '',
  isAuthenticated: false,
  grantType: 'client_credentials',
  headers: [{ key: '', value: '' }],
  queryParams: [{ key: '', value: '' }],
};
